// removed by extract-text-webpack-plugin
module.exports = {"icon-stand":"IconStand-module__icon-stand___FgYpm","circles":"IconStand-module__circles___2Q7vw","icon":"IconStand-module__icon___2Ubjd"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/IconStand/IconStand.module.scss
// module id = 163
// module chunks = 0 1